import React, { useRef, useState } from 'react';
import { theme } from '../../config/theme';

const OTPInput = ({ length = 6, onChange, onComplete }) => {
  const [otp, setOtp] = useState(new Array(length).fill(''));
  const inputRefs = useRef([]);

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    const otpString = newOtp.join('');
    onChange?.(otpString);

    if (value && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    if (otpString.length === length && newOtp.every(digit => digit !== '')) {
      onComplete?.(otpString);
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').slice(0, length);
    if (!/^\d+$/.test(pastedData)) return;

    const newOtp = pastedData.split('').concat(new Array(length).fill('')).slice(0, length);
    setOtp(newOtp);
    onChange?.(pastedData);

    if (pastedData.length === length) {
      onComplete?.(pastedData);
      inputRefs.current[length - 1]?.focus();
    } else {
      inputRefs.current[pastedData.length]?.focus();
    }
  };

  const containerStyles = {
    display: 'flex',
    gap: theme.spacing.md,
    justifyContent: 'center',
  };

  const inputStyles = {
    width: '50px',
    height: '60px',
    fontSize: theme.typography.fontSize['2xl'],
    fontWeight: theme.typography.fontWeight.bold,
    textAlign: 'center',
    border: `2px solid ${theme.colors.border.main}`,
    borderRadius: theme.borderRadius.lg,
    outline: 'none',
    transition: theme.transitions.base,
  };

  return (
    <div style={containerStyles}>
      {otp.map((digit, index) => (
        <input
          key={index}
          ref={el => inputRefs.current[index] = el}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          onFocus={(e) => {
            e.target.select();
            e.target.style.borderColor = theme.colors.border.focus;
          }}
          onBlur={(e) => {
            e.target.style.borderColor = theme.colors.border.main;
          }}
          style={inputStyles}
          autoFocus={index === 0}
        />
      ))}
    </div>
  );
};

export default OTPInput;